export default __webpack_public_path__ + "static/media/filter.2c9a173e.svg";